import { render } from "./VerifyCustomerSizing.vue?vue&type=template&id=00a53c44"
import script from "./VerifyCustomerSizing.vue?vue&type=script&lang=js"
export * from "./VerifyCustomerSizing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__